module.exports = __webpack_public_path__ + "img/ch.7df2574f.svg";